import { ErrorMessage, Field, useField } from 'formik';
import React, { Fragment, type JSX } from 'react';

interface InputProps {
  name: string;
  rows: number;
  placeholder: string;
  cssClass?: string;
  id?: string;
  onBlur?: () => any;
  validate?: (value: string) => string;
}

/**
 * React input field helper with build in error message.
 *
 * @example
 * <Input name='pupil.firstName' placeholder='Voornaam'/>
 */
export const Textarea = (props: InputProps): JSX.Element => {
  const meta = useField(props)[1];
  const { name, placeholder, validate, cssClass, onBlur, id, rows }: InputProps = props;

  const hasError: boolean = (!!meta.touched && !!meta.error);

  return (
    <Fragment>
      <Field className={`form-control ${cssClass} ${hasError ? 'error' : ''}`}
        as="textarea"
        name={name}
        id={id}
        rows={rows}
        onBlur={onBlur}
        validate={validate}
        placeholder={placeholder}/>
      {hasError && <ErrorMessage name={name}
        component="div"
        className="validation-error"/>}
    </Fragment>
  );
};
